import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import Circle from 'react-google-maps/lib/Circle';
import withScriptjs from 'react-google-maps/lib/async/withScriptjs';
import Icon from 'react-fa';
import find from 'lodash/find';
import debounce from 'lodash/debounce';
//const renameKeys = (collection, rename_map) => mapKeys(collection, (value, key) => rename_map[key] || key);
import { GoogleMapControl } from './GoogleMapControl'
import { Coord } from '../../models/Location/mapUtils';
import { setGoogleMap, setResultSelected, setResultHovered, setShowInfobox, setMapControlled, setMapLocation, dragMap } from '../../models/Map/actions';
import { getLatestResults, paramsFromProps } from '../../models/Search';
/* import { debug } from '../../../utils';
 * const log = debug('lego:SearchMap.tsx');*/
import PlaceInfoBox from './PlaceInfoBox';
import mapValues from 'lodash/mapValues';
const styles = require('./SearchMap.less') as any;

//const PROD_GOOGLE_API_KEY = 'AIzaSyB8tpf0vSwoHlDHlj7b1-VjNKy7iVrxUAQ';
const DEV_GOOGLE_API_KEY = 'AIzaSyCyM32-fbpB6_Jp8uNSFsEQ2usNI1Dsn70';
const GOOGLE_API_KEY = DEV_GOOGLE_API_KEY;

const GOOGLE_MAP_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.exp&libraries=places`;
// const GOOGLE_MAP_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.exp&libraries=places`;
import inRange from 'lodash/inRange'
const DEFAULT_ZOOM = 12;

/* interface SearchMapProps {
 * 		center: any;
 * 		markers?: any[];
 * 		offset?: any;
 * 		router: any;
 * }*/
import { shallowEquals } from '../../utils'
import { adjustCenterByFactor, getVerticalScalingFactor } from './utils'
import { getCenter, getUserPosition, positionToLatLngObj } from '../../models/Location';

const mapDispatchToProps = (dispatch) => ({
  ...mapValues({setGoogleMap, setResultSelected, setResultHovered, setShowInfobox, setMapControlled, dragMap},
               ((creator: any) => (...args) => dispatch(creator(...args)))),
  setMapLocation: debounce((args) => dispatch(setMapLocation(args)), 500, {maxWait: 1000}) as any
});

function getAdjustedCenter(state) {
  return adjustCenterByFactor(
		getCenter(state.mapState, state.userPosition),
		state.mapComponent && state.mapComponent(),
		state.browser.lessThan.searchViewLimit ? getVerticalScalingFactor(state.mapState.windowShade) : 0
	)
}

const mapStateToProps = (state, ownProps) => ({
	mapComponent: state.mapComponent && state.mapComponent(),
	results: getLatestResults(state, paramsFromProps({
    // TODO: keyword || latest || nearby
		location: ownProps.location,
		mapState: state.mapState,
		center: new Coord(state.mapState.map_location)
  })),
	mapState: state.mapState,
  zoom: parseInt(state.mapState.map_location.zoom || ownProps.location.query.zoom || DEFAULT_ZOOM),
  userPosition: state.userPosition,
  center: getAdjustedCenter(state),
  browser: state.browser,
});
@connect(mapStateToProps, mapDispatchToProps)
class SearchMap extends React.Component< any, any> {
	setMapPosition(position) {
		const { mapComponent: map, mapState } = this.props;
    let new_position, center;
    if (position) {
      new_position = position;
      new_position.zoom = new_position.zoom || DEFAULT_ZOOM;
    } else {
      center = map.getCenter();
      new_position = {
        latitude: center.lat(),
        longitude: center.lng(),
        zoom: map.getZoom()
      };
    }

		const adjustedNewPosition = adjustCenterByFactor(
			new Coord(new_position),
			map,
			-(this.props.browser.lessThan.searchViewLimit ? getVerticalScalingFactor(mapState.windowShade) : 0)
		)

		return this.props.setMapLocation({
			latitude: adjustedNewPosition.lat,
			longitude: adjustedNewPosition.lng,
			zoom: map.getZoom(),
		})
	};

	shouldComponentUpdate(nextProps, nextState) {
		return !shallowEquals(this.props, nextProps) || !shallowEquals(this.state, nextState)
	}

  renderMapLoading() {
		return (
			<div className={styles.MapLoadingElement}>
				<div><Icon spin name="spinner" /> Loading Map!</div>
			</div>
		);
	}

	renderLoadingResults() {
		return (
			<div className={styles.MapLoadingElement}>
				<div><Icon spin name="spinner" /> Loading Results...</div>
			</div>
		);
	}

	render() {
		const { results, center, zoom, mapState, mapComponent, userPosition, location } = this.props;
		const { selected, hovered, map_controlled } = mapState;

		const isSearch = location.pathname.startsWith('/search')
		//if (results.data && results.data.length === 0) return this.render_empty_results();
    const mapControlled = () => {
			if (map_controlled) { return null; }
			this.props.dragMap();
    }

		const markers = (results.data || []).map((result, key) => ({
			key: result.id, place: result,
			isSelected: (result.id==selected), isHovered: (result.id==hovered),
			position: positionToLatLngObj(result.location.position),
			onMouseOver: () => debounce(() => this.props.setResultHovered(result.id)),
			onMouseOut: () => this.props.setResultHovered(null),
			onClick: () => this.props.setResultSelected(result.id)
		}));

		return (
			<MapHelper setGoogleMAP={this.props.setGoogleMap}
								 className={styles.SearchMap}
								 onClick={(e) => {
										 const infoBox = document.querySelector('.infoBox') as any
										 if (infoBox) {
											 const right = infoBox.offsetLeft + infoBox.offsetWidth
											 const bottom = infoBox.offsetTop + infoBox.offsetHeight
											 if (inRange(e.pixel.x, infoBox.offsetLeft, right) &&
													 inRange(e.pixel.y, infoBox.offsetTop, bottom))
												 return
										 }
										 this.props.setShowInfobox(false)
									 }}
								 containerElement={<div className={styles.MapContainer} />}
								 mapElement={<div className={styles.MapElement} />}
								 onMapChanged={map_controlled ? this.setMapPosition.bind(this) : () => null}
                 centerOnUser={() => this.setMapPosition(getUserPosition(userPosition))}
                 onDragStart={mapControlled}
								 loadingElement={this.renderMapLoading()}
								 setHideInfobox={() => {
										 this.props.setShowInfobox(false) && false}
																}
                 mapComponent={mapComponent}
                 markers={markers}
                 googleMapURL={GOOGLE_MAP_URL}
								 mapState={mapState}
								 center={center}
                 userPosition={userPosition}
								 isSearch={isSearch}
								 zoom={zoom} />
		);
	}
}

import { USER_MARKER_PATH, PLACE_MARKER_NODATA_PATH, PLACE_MARKER_DATA_PATH } from './Markers';
const USER_MARKER = {
  path: USER_MARKER_PATH,
  fillColor: '#2f55c0',
	strokeColor: '#999999',
	fillOpacity: 1,
	scale: 0.25,
	strokeWeight: 1
};
const PLACE_MARKER = {
  path: PLACE_MARKER_NODATA_PATH,
  fillColor: '#2f55c0',
	strokeColor: '#999999',
	fillOpacity: 1,
	scale: 0.25,
	strokeWeight: 1
};
declare var google;

const MapHelper = withGoogleMap(
	({onMapLoad, center, zoom, onClick, markers=[], setGoogleMAP, onMapChanged, onDragStart, userPosition, mapComponent, centerOnUser, mapState:{selected, show_infobox}, isSearch, setHideInfobox, ...props}) => (
			<GoogleMap ref={setGoogleMAP}
								 onMapMounted={setGoogleMAP}
			zoom={zoom}
					defaultCenter={center}
			onClick={onClick}
      onDragStart={onDragStart}
			onZoomChanged={onMapChanged}
									 onDragEnd={onMapChanged}
                   disableDefaultUI={true}
                   zoomControl={true}
                   rotateControl={true}
                   fullScreenControl={true}>
					{/* <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}> */}
				{markers.map((marker, index) =>
					(marker.isSelected || marker.isHovered) ?
																			<Marker icon={{...PLACE_MARKER, fillColor: '#000000'}} zIndex={1000} {...marker}	/>
																		: <Marker icon={PLACE_MARKER} {...marker} /> )}
            <Marker position={positionToLatLngObj(getUserPosition(userPosition))} icon={USER_MARKER} zIndex={600} />
    {mapComponent && <GoogleMapControl controlPosition={google.maps.ControlPosition.RIGHT_BOTTOM}
																			 map={mapComponent} className={styles.GoogleMapControls}>
			<button onClick={centerOnUser} className={styles.LocateButton}><Icon name="crosshairs" /></button></GoogleMapControl>}
            <UserIcon userPosition={userPosition} />
            {selected && markers &&
						 <PlaceInfoBox marker={find(markers, {key: selected})}
													 show={show_infobox && isSearch} close={setHideInfobox} />}
					</GoogleMap>
			));

import { purify } from '../../utils'
const UserIcon = purify((userPosition) =>
            <Circle
                center={positionToLatLngObj(getUserPosition(userPosition))}
                radius={30}
                options={{
                  fillColor: `blue`,
                  fillOpacity: 0.20,
                  strokeColor: `blue`,
                  strokeOpacity: 1,
                  strokeWeight: 1,
}} />)

export default withRouter(SearchMap)



// WEBPACK FOOTER //
// ./src/app/components/SearchMap/SearchMap.tsx